module.exports = __webpack_public_path__ + "images/e3d07620922a2d643f9ad0df1acb9b78.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-locations01.jpg
// module id = ./webpack/assets/img/wheels-locations01.jpg
// module chunks = 0